import { isEmpty } from 'lodash-es';

/**
 * Overall All 态：聚合不限定具体值（isAll=true 且 values 为空）。
 * 与 Select All（isAll=true 且 values 灌满）区分。
 */
export function isOverallAllState(
  isAll: boolean,
  values?: (string | null)[] | null,
): boolean {
  return isAll && isEmpty(values);
}
